export const dateFormats = ['YYYY-MM-DD', 'DD/MM/YYYY', 'MM/DD/YYYY'];

export const timeFormats = ['hh:mm A', 'HH:mm'];

export const timePreciseFormats = ['hh:mm:ss A', 'HH:mm:ss'];
